import { Component, OnInit, OnDestroy } from '@angular/core';
import { Site } from '@shared/models/site';
import { Product } from '@shared/models/product';
import { WwComponentsSummary, WwComponentsSummaryItem } from '../../../../models/shift-validation/ww-components-summary';
import { ProductService } from '../../../../services/product.service';
import { ShiftContextService } from '../../../../services/shift-context.service';
import { ShiftValidationService } from '../../../../services/shift-validation/shift-validation.service';
import { BehaviorSubject, combineLatest, map, Observable, startWith, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { url } from '@shared/helpers/url';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-ww-components',
    templateUrl: './ww-components.component.html',
    styleUrls: ['./ww-components.component.scss']
})
export class WwComponentsComponent implements OnInit, OnDestroy {

    componentsSummary = new BehaviorSubject<WwComponentsSummary>({ items: [] });

    showZeroRows = new FormControl<boolean>(false);

    filteredRows = combineLatest([
        this.componentsSummary,
        this.productService.CurrentProducts,
        this.showZeroRows.valueChanges.pipe(startWith(this.showZeroRows.value))
    ]).pipe(map(([summary, products, showZeroRows]) => {
        let items = summary.items;

        if (!showZeroRows)
            items = items.filter(i => !this.allAreZero(i));

        const prodName = (productId: number) => products.find(p => p.id === productId)?.label ?? 'zzzzz';

        return items.sort((a, b) => prodName(a.productId).localeCompare(prodName(b.productId)));
    }));

    loading: boolean = false;
    site: Site;
    products: Product[] = [];
    subscriptions: Subscription[];
    startupSubscription: Subscription;

    constructor(
        private shiftContextService: ShiftContextService,
        private shiftValidationService: ShiftValidationService,
        private productService: ProductService,
        private route: ActivatedRoute) { }

    ngOnInit() {
        this.loading = true;

        this.subscriptions = [
            combineLatest([
                this.shiftContextService.CurrentContext,
                this.route.params
            ]).subscribe(([context, routeParams]) => {
                this.site = context.site;

                const subinventoryId = parseInt(routeParams.id, 10);
                this.componentsSummary.next(this.shiftValidationService.CurrentMappedSummary<WwComponentsSummary>(url`WhiteWoodComponents/${subinventoryId}`));
                this.loading = false;
            })
        ];
    }

    allAreZero(obj) {
        const temp = { ...obj, productId: 0, sortedOut: 0, sortedInDetail: 0, reclasses: 0, sortOutIsTeardown: 0, sortInIsRepairs: 0, sortInIsHeatTreat: 0};
        return new Set(Object.values(temp).map(v => v ?? 0)).size === 1;
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getProduct(productId: number): Observable<string> {
        return this.productService.FindProduct(productId).pipe(map(p => p?.label));
    }

    sumTotal(selector: string | ((item: WwComponentsSummaryItem) => number)): number {
        const func = typeof selector === 'string'
            ? (row: WwComponentsSummaryItem) => row[selector]
            : selector;

        return (this.componentsSummary.value?.items ?? [])
            .map(func)
            .reduce((agg, cur) => agg + cur, 0);
    }

    lastStep() {
        return false;
    }
}
